import React from "react";
import { Lottie } from "lottie-react";
import { LoaderContainer, LoaderWrapper } from "./Loader.components";
import loadingAnimationData from "./loadingAnimationData.json";

const Loader = ({ width = "100px", containerHeight }) => (
  <LoaderContainer containerHeight={containerHeight}>
    <LoaderWrapper width={width}>
      <Lottie src={loadingAnimationData} loop autoplay />
    </LoaderWrapper>
  </LoaderContainer>
);

export default Loader;
